import { render, staticRenderFns } from "./AddToGroupModal.vue?vue&type=template&id=626cb992"
import script from "./AddToGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports